'use es6';

import PropTypes from 'prop-types';
import { Children, createContext, useContext, useEffect, useState, useRef } from 'react';
import { Map as ImmutableMap } from 'immutable';
import { jsx as _jsx } from "react/jsx-runtime";
const createTrap = (name, valuePropType = PropTypes.oneOf([undefined])) => {
  const contextKey = `${name}[${Math.random()}]`;
  const TrapContext = /*#__PURE__*/createContext();
  const Receive = props => {
    const {
      children,
      onRaise
    } = props;
    const [elementsMap, setElementsMap] = useState(ImmutableMap());
    const isUnmounted = useRef(false);
    useEffect(() => {
      return () => {
        isUnmounted.current = true;
      };
    }, []);
    useEffect(() => {
      if (!isUnmounted.current) {
        onRaise(elementsMap.valueSeq().toArray());
      }
    }, [isUnmounted, elementsMap, onRaise]);
    const updateElementsMap = updater => {
      setElementsMap(curentelementsMap => updater(curentelementsMap));
    };
    const context = useRef({
      [contextKey]: {
        set: (id, value) => updateElementsMap(vals => vals.set(id, value)),
        remove: id => updateElementsMap(vals => vals.remove(id))
      }
    });
    return /*#__PURE__*/_jsx(TrapContext.Provider, {
      value: context.current,
      children: children
    });
  };
  const Raise = props => {
    const context = useContext(TrapContext);
    const {
      children,
      value
    } = props;
    const id = useRef();
    const initialMount = useRef(true);
    useEffect(() => {
      if (initialMount.current) {
        initialMount.current = false;
        if (context && context[contextKey]) {
          id.current = Symbol(`${name}Raise`);
          context[contextKey].set(id.current, value);
        }
      }
    }, [context, id, value]);
    useEffect(() => {
      return () => {
        if (context && context[contextKey]) {
          context[contextKey].remove(id.current);
        }
      };
    }, [id, context]);
    return children && Children.only(children);
  };
  Receive.propTypes = {
    onRaise: PropTypes.func.isRequired,
    children: PropTypes.element
  };

  /* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
  Receive.defaultProps = {
    children: null
  };
  Raise.propTypes = {
    children: PropTypes.element,
    value: valuePropType
  };

  /* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
  Raise.defaultProps = {
    children: null
  };
  return {
    Receive,
    Raise
  };
};
export default createTrap;